import { useSystemAuthState } from 'auth/SystemAuth/context/context';
import React from 'react'

const ErrorPage = () => {
  const authState = useSystemAuthState();
  
  return (
    <div className="customErrorWrapper">
      <div className="serverError"></div>
      <div className="goBackLink">
        <p>Oops, something went wrong.</p>
        <p>Try to refresh this page or feel free to contact us if the problem persists.</p>
        {authState.user && <p>Go back <a href="/">Home</a></p>}
      </div>
    </div>
  )
}

export default ErrorPage